import { useState, useEffect, useCallback } from 'react';

export const useOtpCooldown = (email: string, cooldownSeconds = 60) => {
	const STORAGE_KEY = `sp_otp_cooldown_${email}`;
	const [timeLeft, setTimeLeft] = useState(0);

	useEffect(() => {
		if (!email) return;

		const storedTimestamp = localStorage.getItem(STORAGE_KEY);
		if (storedTimestamp) {
			const expiryTime = parseInt(storedTimestamp, 10);
			const now = Date.now();
			if (expiryTime > now) {
				setTimeLeft(Math.ceil((expiryTime - now) / 1000));
			} else {
				localStorage.removeItem(STORAGE_KEY);
			}
		}
	}, [STORAGE_KEY, email]);

	useEffect(() => {
		if (timeLeft <= 0) return;

		const timer = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					localStorage.removeItem(STORAGE_KEY);
					return 0;
				}
				return prev - 1;
			});
		}, 1000);

		return () => clearInterval(timer);
	}, [timeLeft, STORAGE_KEY]);

	const startCooldown = useCallback(() => {
		if (!email) return;
		const expiryTime = Date.now() + cooldownSeconds * 1000;
		localStorage.setItem(STORAGE_KEY, expiryTime.toString());
		setTimeLeft(cooldownSeconds);
	}, [STORAGE_KEY, cooldownSeconds, email]);

	return {
		timeLeft,
		startCooldown,
		isCooldownActive: timeLeft > 0,
	};
};
